import { Box, Checkbox, Flex, Text } from "@chakra-ui/react";
import { ComponentType } from "react";

export function CustomCheckboxCard(props: {
  value: string;
  label: string;
  icon: ComponentType<any> | string;
  isDisabled?: boolean;
  isChecked?: boolean;
  isComingSoon?: boolean;
  comingSoonText?: string;
  onClick?: () => void;
}) {
  const {
    value,
    label,
    isDisabled = false,
    isChecked = false,
    isComingSoon = false,
    comingSoonText,
    icon,
    onClick,
  } = props;

  const renderIcon = () => {
    if (typeof icon === "string") {
      return (
        <img
          src={icon}
          alt="icon"
          style={{ marginBottom: "2px", width: 16, height: 16 }}
        />
      );
    }

    const IconComponent = icon;
    return <IconComponent size="16px" color="#086AA9" />;
  };

  return (
    <Box as="label" cursor="pointer">
      <input type="hidden" value={value} />
      <Flex
        cursor="pointer"
        borderWidth="1px"
        borderRadius="md"
        borderColor={isChecked ? "blue.500" : "gray.300"}
        bg={isDisabled ? "#F4F4F5" : "white"}
        color={isDisabled ? "#A1A1AA" : "#52525B"}
        px={4}
        py={3}
        alignItems="center"
        justifyContent="space-between"
        gap={3}
        transition="all 0.2s"
        _hover={{ borderColor: "blue.300" }}
        minH="60px"
        w="220px"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          if (!isDisabled && onClick) {
            onClick();
          }
        }}
      >
        <Flex align="center" gap={2} pointerEvents="none">
          {renderIcon()}
          <Text>{label}</Text>
          {isComingSoon && <Text whiteSpace={"nowrap"}>-</Text>}
          {isComingSoon && <Text whiteSpace={"nowrap"}>{comingSoonText}</Text>}
        </Flex>

        <Checkbox
          isChecked={isChecked}
          isDisabled={isDisabled}
          pointerEvents="none"
          colorScheme="blue"
        />
      </Flex>
    </Box>
  );
}
